import { ReactNode } from 'react';
import { Locale } from '../../domain/Internationalization/entities';
import { IInternationalizationService } from '../../domain/Internationalization/usecases/InternationalizationService';
import { Translation } from '../../domain/Internationalization/entities';

export type InternationalizationProviderProps = {
  internationalizationService: IInternationalizationService;
  language?: Locale;
  loaderComponent?: ReactNode;
  errorComponent?: ReactNode;
};

export type InternationalizationState = {
  availableLanguages: Locale[];
  translations: Translation[];
  language: Locale;
  languageChanged: boolean;
};

export type InternationalizationAction = {
  type: InternationalizationContextActionTypes | any;
  payload?: any;
};

export enum InternationalizationContextActionTypes {
  SetAvailableLanguages = '@@Internationalization/SET_AVAILABLE_LANGUAGES',
  SetTranslations = '@@Internationalization/SET_TRANSLATIONS',
  SetLanguage = '@@Internationalization/SET_LANGUAGE',
}

export type InternationalizationDispatchOutput = {
  setAvailableLanguages: (payload: Locale[]) => void;
  setLanguage: (payload: number) => void;
};
